import axiosInstance from "../../../utils/axios";
import { ROLE } from "../../../utils/Constants";

const options = { role: ROLE.BUSINESS };
const path = "/common";
const publicPath = "business/auth";

export const ManageBankAccountDetails = async (country) => {
  return await axiosInstance(options).get(`${path}/business/configure-bank-account`, {
    params: country ? { country } : {},
  });
};

export const GetBankAccountInfo = async () => {
  return await axiosInstance(options).get(`${path}/business/get-bank-account-info`);
};

export const SaveBankDetails = async (values) => {
  return await axiosInstance(options).post(`${path}/business/save-bank-details`, values);
};

export const FetchSubsciptionPlans = async () => {
  return await axiosInstance(options).get(`${path}/subscriptions/plans`);
};

export const PuchaseSubsciptionPlan = async (priceId) => {
  return await axiosInstance(options).post(`${path}/subscriptions/create`,{priceId});
};

export const CancelSubsciptionPlan = async (userSubscriptionID) => {
  return await axiosInstance(options).patch(`${path}/subscriptions/cancel`,{userSubscriptionID});
};

// Below API's are being used in the Edit Business Info
export const categoriesList = async (values) => {
  return await axiosInstance(options).get(`${publicPath}/categories-list`, values);
};

export const subcategoriesList = async (values) => {
  return await axiosInstance().post(`${publicPath}/subcategories-list`, values);
};

export const editBusinessInfo = async (values) => {
  return await axiosInstance(options).post(`${path}/edit`, values);
};